module.exports = __webpack_public_path__ + "static/media/vodafoneIVR.37db7616.png";